import { enUS, uk, pl } from 'date-fns/locale';
import type { Locale } from 'date-fns';

export const DEFAULT_DATE_FNS_LOCALE: Locale = enUS;

export const DATE_FNS_LOCALE_MAP: Record<string, Locale> = {
  en: enUS,
  uk: uk,
  pl: pl,
};
